module.exports = __webpack_public_path__ + "161d6423829a32f1f00b8bc060251439.svg";